import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import Header from '../../components/Header/Header';
import DrawerMenu from '../../components/DrawerMenu/DrawerMenu';
import { DRAWER_WIDTH } from '../../shared/constants';

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
  open?: boolean;
}>(({ theme, open }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${DRAWER_WIDTH}px`,
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

function DashboardLayout(): JSX.Element {
  const [open, setOpen] = React.useState(false);

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Header open={open} handleDrawerOpen={handleDrawerOpen} />
      <DrawerMenu open={open} handleDrawerClose={handleDrawerClose} />
      <Main open={open}>
        <DrawerHeader />
        <Box sx={{ maxWidth: 1360, m: '0 auto' }}>
          <Outlet />
        </Box>
      </Main>
    </Box>
  );
}

export default DashboardLayout;
